import React, { useEffect, useState } from 'react';
import * as mixpanel from 'mixpanel-browser';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { Button } from '@mui/material';

export default function HotelCardOld() {
  const url = `${process.env.HOTEL_OLD_API_URL}`;
  const [hotels, setHotels] = useState([]);
  useEffect(() => {
    fetch(url)
      .then((response) => response.json())
      .then((data) => setHotels(data.data))
      .catch((error) => console.log('error', error));
  }, []);

  return (
    <Container fluid bg="black">
      <Container className="p-4 justify-content-center">
        {window?.is_admin ? (
          <p className="super-funk">
            <Button className="btn sort-other-travel-portal" onClick={() => window?.App?.pop_admin('/hotels/ordering/')}>
              Sort Business Order
            </Button>
          </p>
        ) : null}
        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
          {hotels.map((hotel) => (
            <Col key={hotel.id}>
              <div
                rel="noreferrer"
                className="btn-link"
                onClick={() => {
                  window.open(`/travel/hotels/${hotel.slug}`, '_blank');
                  mixpanel.init('f7c2b5bee408ce64398ba6934f6dab84');
                  mixpanel.track('Benefit Link Clicked', { 'Benefit Type': 'Hotel', 'Benefit Name': 'view hotel old' });
                }}
              >
                <Card className="select-list-card" style={{ cursor: 'pointer' }}>
                  <Card.Img variant="top" src={hotel.main_img_url.large} />
                  <Card.Body>
                    <Card.Subtitle className="old-card-city">{!hotel.state ? 'Worldwide' : hotel.destination_ref}</Card.Subtitle>
                    <Card.Title className="old-card-title">{hotel.name}</Card.Title>
                    <Card.Text className="old-card-perk">{hotel.detail_bullets[0]}</Card.Text>
                  </Card.Body>
                </Card>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  );
}
